/**
 * Whisky Library PostHog helper — safe to call before posthog.init() completes.
 * All theme and funnel scripts should use window.whiskyPosthog.*
 */
(function (window) {
  'use strict';

  var queue = [];
  var sdkReady = false;

  function getPosthog() {
    return typeof window.posthog !== 'undefined' ? window.posthog : null;
  }

  function isSdkReady() {
    var ph = getPosthog();
    return !!(ph && ph.__loaded);
  }

  function run(method, args) {
    var ph = getPosthog();
    if (!ph || typeof ph[method] !== 'function') return false;
    try {
      ph[method].apply(ph, args);
      return true;
    } catch (err) {
      return false;
    }
  }

  function enqueue(method, args) {
    queue.push({ method: method, args: args });
  }

  function flush() {
    if (!queue.length) return;
    var pending = queue.slice();
    queue.length = 0;
    pending.forEach(function (item) {
      run(item.method, item.args);
    });
  }

  function call(method, args) {
    if (isSdkReady()) {
      run(method, args);
      return;
    }
    enqueue(method, args);
  }

  function markSdkReady() {
    if (sdkReady) return;
    sdkReady = true;
    flush();
    if (isDebug()) {
      console.info('[whiskyPosthog] SDK ready, queue flushed');
    }
  }

  function isDebug() {
    try {
      return new URLSearchParams(window.location.search).get('ph_debug') === '1';
    } catch (e) {
      return false;
    }
  }

  function capture(event, properties) {
    if (!event) return;
    var props = properties || {};
    props.page_path = props.page_path || window.location.pathname;
    props.page_url = props.page_url || window.location.href;
    if (isDebug()) {
      console.info('[whiskyPosthog] capture', event, props);
    }
    call('capture', [event, props]);
  }

  function register(properties) {
    if (!properties) return;
    call('register', [properties]);
  }

  function registerOnce(properties) {
    if (!properties) return;
    call('register_once', [properties]);
  }

  function identify(distinctId, properties) {
    if (!distinctId) return;
    call('identify', [distinctId, properties || {}]);
  }

  function setPersonProperties(properties) {
    if (!properties) return;
    call('setPersonProperties', [properties]);
  }

  function getQuizSessionId() {
    try {
      return (window.localStorage.getItem('quiz_sessionId') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function getQuizNavSource() {
    try {
      return sessionStorage.getItem('quiz_nav_source') || '';
    } catch (e) {
      return '';
    }
  }

  function getTasteProfileResult() {
    var root = document.querySelector('.taste-profile-page');
    if (!root) return '';
    return (root.getAttribute('data-taste-profile') || '').trim();
  }

  function funnelContext(extra) {
    var ctx = {
      quiz_session_id: getQuizSessionId(),
      quiz_nav_source: getQuizNavSource(),
      taste_profile_result: getTasteProfileResult(),
      shopify_template: window._template
        ? [window._template.directory, window._template.name, window._template.suffix].filter(Boolean).join('.')
        : undefined
    };
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (key) {
        ctx[key] = extra[key];
      });
    }
    return ctx;
  }

  window.whiskyPosthog = {
    capture: capture,
    register: register,
    registerOnce: registerOnce,
    identify: identify,
    setPersonProperties: setPersonProperties,
    funnelContext: funnelContext,
    getQuizSessionId: getQuizSessionId,
    getQuizNavSource: getQuizNavSource,
    getTasteProfileResult: getTasteProfileResult,
    flush: flush,
    markSdkReady: markSdkReady,
    isSdkReady: isSdkReady,
    isDebug: isDebug
  };

  function tryMarkReady() {
    if (isSdkReady()) {
      markSdkReady();
      return true;
    }
    return false;
  }

  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    if (tryMarkReady() || attempts >= 150) clearInterval(timer);
  }, 100);

  document.addEventListener('DOMContentLoaded', tryMarkReady);
  window.addEventListener('whisky-posthog-ready', markSdkReady);
})(window);
